import React from "react";
import Cta from "@qlik/qlik/src/components/Cta";
import Media from "@qlik/qlik/src/components/Media";
import RichText from "@qlik/qlik/src/components/RichText";
import * as styles from "./styles.module.css";
/**
 * Renders a small headshot card with media, name, country, and title.
 * @param {Object} props - The component props.
 * @param {string} props.media - The media URL.
 * @param {string} props.name - The name of the person.
 * @param {string} props.country - The country of the person.
 * @param {string[]} props.title - The title of the person.
 * @returns {JSX.Element} The rendered component.
 */

const SingleCardHeadshotSm = ({ media, name, country, title, richcontent, ctaList }) => {
    return (
        <div className="flex flex-col">
            <div className="flex-1">
                {media && <Media media={media} className="w-full aspect-[7/5] object-cover mb-5 object-left rounded" />}
                {country && <p className="mb-2.5 tag-2">{country}</p>}
                {name && <h3 className="mb-1.5 title-5">{name}</h3>}
                <p className="mb-2.5 tag-3 leading-tight tracking-normal text-stone">
                    {title?.map((line) => (
                        <span key={line} className=" md:block">
                            {line}
                        </span>
                    ))}
                </p>
                {richcontent?.body?.raw && (
                    <RichText data={richcontent} className={`text-left mt-3.75 ${styles.richtextContent}`} />
                )}
                {ctaList?.length > 0 && (
                    <div className="mx-auto flex flex-wrap justify-start items-center gap-3.75 lg:gap-7.5 mt-7">
                        {ctaList?.map((button) => (
                            <Cta key={button.id} data={button} />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default SingleCardHeadshotSm;
